import { globalizeSelectors } from '../Utils';
import { ERROR_CRITICAL, ERROR_WARNING } from 'js/Constants';
import type {
  ErrorPayload,
  ErrorsAction,
  ErrorsState,
  ErrorType,
} from '../types/Errors';
/**
 * Just a simple flag to notify the UI that progress modal needs to be shown!
 */

/*
 * action types
 */

const types = {
  SET_ERROR: 'ERRORS/SET_ERROR',
  CLEAR: 'ERRORS/CLEAR',
} as const;

function payloadAs<Payload>(action: ErrorsAction): Payload {
  return action.payload as Payload;
}

/*
 * action creators
 */

const actions = {
  showCriticalError: (
    msg: string,
    e: unknown,
    type: ErrorType = ERROR_CRITICAL
  ): ErrorsAction<ErrorPayload> => ({
    type: types.SET_ERROR,
    payload: { msg, e, type },
  }),
  showError: (
    msg: string,
    e: unknown,
    title: string | null,
    type: ErrorType = ERROR_WARNING
  ): ErrorsAction<ErrorPayload> => ({
    type: types.SET_ERROR,
    payload: { msg, e, type, title },
  }),
  clearError: (): ErrorsAction => ({ type: types.CLEAR }),
};

const mountPath = 'errors'; // mount point in global state, must match root reducer

/**
 * Handling login and log out site actions
 */

const initialState: ErrorsState = {
  msg: null,
  e: null,
  type: ERROR_CRITICAL,
  title: null, // use default
};

function reducer(
  state: ErrorsState = initialState,
  action: ErrorsAction
): ErrorsState {
  switch (action.type) {
    case types.SET_ERROR: {
      return { ...state, ...payloadAs<ErrorPayload>(action) };
    }
    case types.CLEAR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

// selectors

const localSelectors = {
  error: (state: ErrorsState): ErrorsState => state,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export { types as actionTypes, actions as default, selectors, reducer };
